<template>
	<div>
		<div class="actDiv">
			<a-button  size="small"   icon="plus" @click="addFlag = true" style="margin-right: 1.25rem;">新增单价</a-button>
			<a-button  size="small"   icon="retweet" @click="adjustFlag=true">调整单价</a-button>
		</div>
		<a-table  size="small" :columns="columns" :data-source="list" bordered :loading="loading"  rowKey="PID" :pagination="false"  :scroll="{y:600}">
			<span slot="theAction" slot-scope="text, record">
				<a-popconfirm title="确定要删除该条记录?" ok-text="确定" cancel-text="取消" placement="bottom" @confirm="deleteContent(record)">
					<a-button size="small" type="link">删除</a-button>
				</a-popconfirm>
			</span>
		</a-table>
		<a-drawer  title="新增单价" :visible="addFlag"  width="450" @close="onAddClose" :destroyOnClose='true' :maskClosable="false">
			<AddBasicPrice @cancelAdd="onAddClose" @refreshList="queryDataList"/>
		</a-drawer>
		<a-modal  v-model="adjustFlag" title="调整单价" @ok="adjustBasicPrice" @cancel="closeAdjustWindow" :maskClosable="false" centered>
			<a-form-model layout="inline">
				<a-form-model-item label="原单价">
					<a-select style="width: 8.5rem" placeholder="请选择单价" v-model="oldBasicPrice" >
						<a-select-option v-for="(item,index) in list" :key="item.PID" :value="item.PID">{{item.PriceKindName}}</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="新单价">
					<a-select  style="width: 8.5rem"  placeholder="请选择单价" v-model="newBasicPrice" >
						<a-select-option v-for="(item,index) in list" :key="item.PID" :value="item.PID">{{item.PriceKindName}}</a-select-option>
					</a-select>
				</a-form-model-item>
			</a-form-model>
		</a-modal>
	</div>
</template>

<script>
	const columns=[
		{
			title: '单价名',
			dataIndex: 'PriceKindName',
			width:100,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '备注',
			dataIndex: 'Remark',
			width:120,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '基本单价名',
			dataIndex: 'BasicPriceName',
			width:140,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '一阶单价',
			dataIndex: 'BasicPriceFirst',
			width:80,
			className:'v-cell',
			align:'center',
		},
		{
			title: '一阶超量',
			dataIndex: 'BasicFirstOver',
			width:80,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '二阶单价',
			dataIndex: 'BasicPriceSecond',
			width:80,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title:'二阶超量',
			dataIndex:'BasicSecondOver',
			width:80,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title:'三阶单价',
			dataIndex:'BasicPriceThird',
			width:80,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title:'每人增量',
			dataIndex:'perYL',
			width:80,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
		    title: '操作',
		    key: 'pid',
		    scopedSlots: { customRender: 'theAction' },
			width:60,
			className:'v-cell',
			align:'center',
		  },
	];
	import AddBasicPrice from '../components/AddBasicPrice.vue'
	export default{
		components:{
			AddBasicPrice,
		},
		data(){
			return{
				columns,
				addFlag:false,
				loading:true,
				adjustFlag:false,
				list:[],
				oldBasicPrice:undefined,
				newBasicPrice:undefined,
			}
		},
		methods:{
			queryDataList:function(){
				let url = this.Api.getLastUrl(this.Api.BASIC_PRICE_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.list = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
					this.loading = false;
				});
			},
			deleteContent:function(item){
				let url = this.Api.getLastUrl(this.Api.BASIC_PRICE_DELETE_URL);
				let param = {theId:item.PID};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.queryDataList();
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
				
			},
			onAddClose:function(){
				this.addFlag = false;
			},
			adjustBasicPrice:function(){
				if(this.oldBasicPrice == undefined){
					this.$message.warning('原单价不能为空');
					return;
				}
				if(this.newBasicPrice == undefined){
					this.$message.warning('新单价不能为空');
					return;
				}
				if(this.oldBasicPrice == this.newBasicPrice){
					this.$message.warning('新旧单价不可相同');
					return;
				}
				let url = this.Api.getLastUrl(this.Api.BASIC_PRICE_ADJUST_URL);
				let param = {newBasicPrice:this.newBasicPrice,oldBasicPrice:this.oldBasicPrice};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success('单价调整成功');
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
				this.closeAdjustWindow();
			},
			closeAdjustWindow:function(){
				this.adjustFlag = false;
				this.oldBasicPrice = undefined;
				this.newBasicPrice = undefined;
			},
		},
		created() {
			this.queryDataList();
		}
	}
</script>

<style>
</style>
